// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2El_f","requiredAsterisk":"Info_requiredAsterisk__x3GrT"};